import styled from "styled-components";

export const HelperText = styled.p`
  font-size: 1rem;
  color: #1a1a1a;
  margin-top: -10px;
  margin-bottom: 10px;
`;
